import { fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

export const createBaseQuery = () => {
    return fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");

            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }

            return headers;
        },
    });
};

export const createBaseQueryFile = () => {
    return fetchBaseQuery({
        baseUrl: process.env.REACT_APP_FILE_API_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem("token");

            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }

            return headers;
        },
    });
};

export const createBaseFileQuery = (baseUrl) => {
    return fetch(baseUrl, {
        method: 'get',
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: '*'
        }
    }).then(response => response.blob())
        .then(json => {
            return json
        })
};